import React from "react";
import StyledLabel from "./Label.styled";
import { ILabel } from "./Label.types";

const Label = (props: ILabel): JSX.Element => <StyledLabel {...props} />;

export default Label;
